import { c as _c } from "react/compiler-runtime";
import { Button, Dialog, Field, NativeSelect, Portal, RadioCard, SimpleGrid, Text, Textarea, VStack } from '@chakra-ui/react';
import { Checkbox } from '@src/components/chakra-ui/checkbox';
import { commentsForGenerate, type GenerateComment, type GenerateDraftRequest, generateFileCount, generateFilesLabel, type GenerateScope, type GenerateToolChoice } from '@src/components/sco/GenerateReply/generateReply';
import React, { useEffect, useState } from 'react';
type GenerateDialogComment = GenerateComment & {
  body: string;
};
function snippet(body: string): string {
  const text = body.replace(/\s+/g, ' ').trim();
  if (!text) {
    return 'No text';
  }
  return text.length > 72 ? `${text.slice(0, 71)}…` : text;
}

/** "Last message" or "This conversation", as one radio group to a keyboard and a screen reader. */
function ScopeTiles(props) {
  const $ = _c(11);
  const t0 = props.disabled;
  const t1 = props.value;
  let t2;
  if ($[0] !== props) {
    t2 = event => {
      if (event.value === "last" || event.value === "thread") {
        props.onChange(event.value);
      }
    };
    $[0] = props;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props.items) {
    t3 = props.items.map(_temp);
    $[2] = props.items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <SimpleGrid columns={2} gap={2}>{t3}</SimpleGrid>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.disabled || $[7] !== props.value || $[8] !== t2 || $[9] !== t4) {
    t5 = <RadioCard.Root aria-label="What to include" disabled={t0} size="sm" value={t1} variant="outline" onValueChange={t2}>{t4}</RadioCard.Root>;
    $[6] = props.disabled;
    $[7] = props.value;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}

/**
 * How Generate chooses context. The reply is written into the box. Nothing is sent.
 * Drafts and unsent messages are not offered. "This reply" is the account's reply tool.
 * Another chat tool adds that tool's prompt and knowledge.
 *
 * Shared by the staff chat composer and the CRM desk composer; it knows neither.
 */
function _temp(item) {
  return <RadioCard.Item key={item.value} colorPalette="gray" value={item.value}><RadioCard.ItemHiddenInput /><RadioCard.ItemControl><RadioCard.ItemContent><RadioCard.ItemText fontWeight="bold">{item.label}</RadioCard.ItemText><Text color="fg.muted" fontSize="xs">{item.hint}</Text></RadioCard.ItemContent></RadioCard.ItemControl></RadioCard.Item>;
}
export function GenerateReplyDialog(props) {
  const $ = _c(74);
  let t0;
  if ($[0] !== props.tools) {
    t0 = props.tools || [];
    $[0] = props.tools;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tools = t0;
  const [scope, setScope] = useState("last");
  const [includeFiles, setIncludeFiles] = useState(true);
  const [instruction, setInstruction] = useState("");
  const [viaToolId, setViaToolId] = useState("");
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(null);
  let t1;
  let t2;
  if ($[2] !== props.open) {
    t1 = () => {
      if (!props.open) {
        setViaToolId("");
      }
    };
    t2 = [props.open];
    $[2] = props.open;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let close;
  let run;
  let sent;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] !== confirming || $[6] !== error || $[7] !== includeFiles || $[8] !== instruction || $[9] !== props || $[10] !== scope || $[11] !== tools || $[12] !== viaToolId) {
    sent = commentsForGenerate(props.comments, "thread");
    const last = sent[sent.length - 1];
    const fileCount = generateFileCount(props.comments, scope);
    const filesOn = fileCount > 0 && includeFiles;
    let t8;
    if ($[26] !== props) {
      t8 = function close() {
        if (props.busy) {
          return;
        }
        setConfirming(false);
        props.onClose();
      };
      $[26] = props;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    close = t8;
    let t9;
    if ($[28] !== filesOn || $[29] !== instruction || $[30] !== props || $[31] !== scope || $[32] !== viaToolId) {
      t9 = async function run() {
        setError(null);
        const message = await props.onGenerate({
          includeFiles: filesOn,
          instruction,
          scope,
          toolId: viaToolId || null
        });
        setError(message);
        setConfirming(false);
      };
      $[28] = filesOn;
      $[29] = instruction;
      $[30] = props;
      $[31] = scope;
      $[32] = viaToolId;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    run = t9;
    T4 = Dialog.Root;
    t6 = props.open;
    if ($[34] !== close) {
      t7 = event => {
        if (!event.open) {
          close();
        }
      };
      $[34] = close;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    T3 = Portal;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Dialog.Backdrop />;
      $[36] = t5;
    } else {
      t5 = $[36];
    }
    T2 = Dialog.Positioner;
    T1 = Dialog.Content;
    const t10 = confirming ? "Replace what is in the box?" : "Generate a reply";
    if ($[37] !== t10) {
      t4 = <Dialog.Header><Dialog.Title>{t10}</Dialog.Title></Dialog.Header>;
      $[37] = t10;
      $[38] = t4;
    } else {
      t4 = $[38];
    }
    T0 = Dialog.Body;
    t3 = confirming ? <Text fontSize="sm">Generating a reply replaces what is in the box and any saved draft stays until you save this one. Nothing is sent.</Text> : <VStack align="stretch" gap={4}><Field.Root><Field.Label>Run through</Field.Label><NativeSelect.Root disabled={props.busy}><NativeSelect.Field aria-label="Run through" value={viaToolId} onChange={event_0 => setViaToolId(event_0.target.value)}><option value="">This reply</option>{tools.map(_temp2)}</NativeSelect.Field><NativeSelect.Indicator /></NativeSelect.Root><Text color="fg.muted" fontSize="xs">Uses this inbox's AI reply settings. Picking a chat tool adds that tool's prompt and knowledge.</Text></Field.Root><ScopeTiles disabled={props.busy} value={scope} items={[{
        label: "Last message",
        hint: last ? snippet(last.body) : "No message",
        value: "last"
      }, {
        label: "This conversation",
        hint: sent.length === 1 ? "1 message" : `${sent.length} messages`,
        value: "thread"
      }]} onChange={setScope} /><Checkbox checked={filesOn} disabled={props.busy || fileCount === 0} size="sm" onCheckedChange={event_1 => setIncludeFiles(event_1.checked === true)}>{generateFilesLabel(fileCount)}</Checkbox><Field.Root><Field.Label>Additional instruction</Field.Label><Textarea disabled={props.busy} maxLength={4000} placeholder="Optional. For example: two sentences, and mention Thursday." rows={3} value={instruction} onChange={event_2 => setInstruction(event_2.target.value)} /></Field.Root>{error ? <Text color="fg.error" fontSize="sm" role="alert">{error}</Text> : <Text color="fg.muted" fontSize="xs">Drafts and unsent messages stay out. Nothing is sent.</Text>}</VStack>;
    $[5] = confirming;
    $[6] = error;
    $[7] = includeFiles;
    $[8] = instruction;
    $[9] = props;
    $[10] = scope;
    $[11] = tools;
    $[12] = viaToolId;
    $[13] = T0;
    $[14] = T1;
    $[15] = T2;
    $[16] = T3;
    $[17] = T4;
    $[18] = close;
    $[19] = run;
    $[20] = sent;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    T0 = $[13];
    T1 = $[14];
    T2 = $[15];
    T3 = $[16];
    T4 = $[17];
    close = $[18];
    run = $[19];
    sent = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
  }
  let t8;
  if ($[39] !== T0 || $[40] !== t3) {
    t8 = <T0>{t3}</T0>;
    $[39] = T0;
    $[40] = t3;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  let t9;
  if ($[42] !== close || $[43] !== confirming || $[44] !== props.busy) {
    t9 = confirming ? <Button disabled={props.busy} variant="outline" onClick={() => setConfirming(false)}>Back</Button> : <Button disabled={props.busy} variant="outline" onClick={close}>Cancel</Button>;
    $[42] = close;
    $[43] = confirming;
    $[44] = props.busy;
    $[45] = t9;
  } else {
    t9 = $[45];
  }
  const t10 = !confirming && sent.length === 0;
  let t11;
  if ($[46] !== confirming || $[47] !== props.needsConfirm || $[48] !== run) {
    t11 = () => {
      if (!confirming && props.needsConfirm) {
        setConfirming(true);
        return;
      }
      run();
    };
    $[46] = confirming;
    $[47] = props.needsConfirm;
    $[48] = run;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== props.busy || $[51] !== t10 || $[52] !== t11) {
    t12 = <Button colorPalette="orange" disabled={t10} loading={props.busy} onClick={t11}>Generate</Button>;
    $[50] = props.busy;
    $[51] = t10;
    $[52] = t11;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  let t13;
  if ($[54] !== t12 || $[55] !== t9) {
    t13 = <Dialog.Footer>{t9}{t12}</Dialog.Footer>;
    $[54] = t12;
    $[55] = t9;
    $[56] = t13;
  } else {
    t13 = $[56];
  }
  let t14;
  if ($[57] !== T1 || $[58] !== t13 || $[59] !== t4 || $[60] !== t8) {
    t14 = <T1>{t4}{t8}{t13}</T1>;
    $[57] = T1;
    $[58] = t13;
    $[59] = t4;
    $[60] = t8;
    $[61] = t14;
  } else {
    t14 = $[61];
  }
  let t15;
  if ($[62] !== T2 || $[63] !== t14) {
    t15 = <T2>{t14}</T2>;
    $[62] = T2;
    $[63] = t14;
    $[64] = t15;
  } else {
    t15 = $[64];
  }
  let t16;
  if ($[65] !== T3 || $[66] !== t15 || $[67] !== t5) {
    t16 = <T3>{t5}{t15}</T3>;
    $[65] = T3;
    $[66] = t15;
    $[67] = t5;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== T4 || $[70] !== t16 || $[71] !== t6 || $[72] !== t7) {
    t17 = <T4 open={t6} onOpenChange={t7}>{t16}</T4>;
    $[69] = T4;
    $[70] = t16;
    $[71] = t6;
    $[72] = t7;
    $[73] = t17;
  } else {
    t17 = $[73];
  }
  return t17;
}
function _temp2(tool) {
  return <option key={tool.toolId} value={tool.toolId}>{tool.label}</option>;
}